import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

export const FAQ = () => {
  const { t } = useTranslation();

  const faqs = [
    {
      question: t('faq.q1', 'How does the AI evaluation work?'),
      answer: t(
        'faq.a1',
        'Our AI analyzes your Christmas tree photo considering lighting, ornaments, symmetry, creativity, and 2025 decoration trends. You receive an instant score from 0-10 with personalized feedback.'
      ),
    },
    {
      question: t('faq.q2', 'Is it free to use?'),
      answer: t(
        'faq.a2',
        'Yes! You get one free evaluation to try the service. After that, you can create a free account for more evaluations or upgrade to premium for detailed insights and trend analysis.'
      ),
    },
    {
      question: t('faq.q3', 'What are premium insights?'),
      answer: t(
        'faq.a3',
        'Premium insights include detailed analysis by category (lighting, ornaments, symmetry, creativity), 2025 trends matching your tree, specific improvement suggestions, and comparative ranking with other trees.'
      ),
    },
    {
      question: t('faq.q4', 'Can I share my tree rating?'),
      answer: t(
        'faq.a4',
        'Absolutely! After evaluation, you can share your tree score on Instagram Stories, WhatsApp, and other social networks with a beautiful personalized image.'
      ),
    },
    {
      question: t('faq.q5', 'What are the 2025 Christmas trends?'),
      answer: t(
        'faq.a5',
        'The main 2025 trends are: Contemporary Minimalist (neutral tones, sustainable materials), Rustic & Handmade (natural elements, artisan crafts), Tech & Smart (LED lights with app control), and Glamorous Maximalist (vibrant colors, luxury ornaments).'
      ),
    },
    {
      question: t('faq.q6', 'How can I contact support?'),
      answer: t(
        'faq.a6',
        'For questions, suggestions, or issues, contact us at arvore.velha@seventysete.com. We will respond as soon as possible!'
      ),
    },
  ];

  return (
    <section className="w-full max-w-3xl mx-auto py-12 px-4">
      <h2 className="text-3xl font-bold text-center text-foreground mb-8">
        {t('faq.title', 'Frequently Asked Questions')}
      </h2>
      
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger className="text-left text-foreground hover:text-primary">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
